import { render, staticRenderFns } from "./UpdateMarks.vue?vue&type=template&id=56fd826d"
import script from "./UpdateMarks.vue?vue&type=script&lang=js"
export * from "./UpdateMarks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports